/**
 * The user action logged for BI purpose.
 * Note: Keep the enums Alphabetically Sorted
 */
export enum ActionScenario {
  AddListFilter = 'addMessageListFilter',
  AddNotifyAllMembers = 'addNotifyAllMembers',
  AddProxyEmail = 'addProxyEmail',
  AddTeamMember = 'addTeamMember',
  BulkChangeMessageAssignee = 'bulkChangeMessagesAssignee',
  BulkRemoveMessageAssignee = 'bulkRemoveMessagesAssignee',
  BulkUpdateMessageState = 'bulkUpdateMessagesState',
  ChangeMessageAssignee = 'changeMessageAssignee',
  ClearSearchList = 'clearSearchList',
  DisableMessageDetailsNotificationSetting = 'disableMessageDetailsNotificationSetting',
  DisableNotifyOnMessageCreateNotificationSetting = 'disableNotifyOnMessageCreateNotificationSetting',
  EnableMessageDetailsNotificationSetting = 'enableMessageDetailsNotificationSetting',
  EnableNotifyOnMessageCreateNotificationSetting = 'enableNotifyOnMessageCreateNotificationSetting',
  FollowMessage = 'followMessage',
  OpenConversation = 'openConversation',
  OpenSettingsModal = 'openSettingsModal',
  RemoveChannelTab = 'removeChannelTab',
  RemoveListFilter = 'removeMessageListFilter',
  RemoveMessageAssignee = 'removeMessageAssignee',
  RemoveNotifyAllMembers = 'removeNotifyAllMembers',
  RemoveProxyEmail = 'removeProxyEmail',
  RemoveTeamMember = 'removeTeamMember',
  ReplyEmailMessage = 'replyEmailMessage',
  SearchList = 'searchList',
  SortListColumns = 'sortListCols',
  StartAConversation = 'startConversation',
  StartGetStartedWizard = 'startGetStartedWizard',
  SubmitGetStartedForm = 'submitGetStartedForm',
  Test = 'test',
  UpdateMessageState = 'updateMessageState',
  ViewEmailMessage = 'viewEmailMessage',
  ViewMessageDetails = 'viewMessageDetails',
  ViewNewMessageDetails = 'viewNewMessageDetails'
}

/**
 * Note: Keep the enums Alphabetically Sorted
 */
export enum ActionScenarioType {
  ConversationsPanel = 'cehConversationsPanel',
  Email = 'email',
  GetStarted = 'cehGetStarted',
  GetStartedWizard = 'cehGetStartedWizard',
  MessageDetails = 'cehMessageDetails',
  Messages = 'cehMessages',
  RemoveTab = 'removeTab',
  Settings = 'cehSettings',
  Test = 'cehTest'
}

/**
 * Note: Keep the enums Alphabetically Sorted
 */
export enum PanelType {
  ConversationsPanel = 'conversationsPanel',
  GetStartedPanel = 'getStartedPanel',
  GetStartedWizard = 'getStartedWizard',
  MessageDetails = 'messageDetails',
  Messages = 'messages',
  Settings = 'settings',
  TabRemoveDialog = 'tabRemoveDialog',
  Test = 'test'
}

/**
 * How a panel was opened up
 * Sample values: nav, notification, direct, toast, userInitiated, update,
 * login, appNav, redererTerminated
 */
export enum PanelLaunchMethod {
  ActivityFeed = 'activityFeed',
  AppNav = 'appNav',
  Direct = 'direct',
  Login = 'login',
  Nav = 'nav',
  Notification = 'notification',
  Posts = 'posts',
  Toast = 'toast',
  Update = 'update',
  UserInitiated = 'userInitiated'
}

export enum EventBaseType {
  /***
   * casing is matching teams implementation
   */
  PanelAction = 'panelaction',
  /***
   * casing is matching teams implementation
   */
  PanelView = 'panelview'
}

export enum EventType {
  Scenario = 'scenario',
  Trace = 'trace',
  UserBI = 'userbi'
}

export enum ActionGesture {
  Click = 'click',
  Hover = 'hover',
  KeyPress = 'keypress',
  None = 'none',
  Scroll = 'scroll'
}

export enum UserBiColumns {
  ActionOutcome = 'Action.Outcome',
  Gesture = 'Action.Gesture',
  ModuleName = 'Module.Name',
  /**
   * Summary of the module's content. Should not include any channel name or team name.
   * Sample values: taskBarIcon item clicked, Send, chat toast, Minimize desktop app, show new messages button,
   * toast, Close/Minimize desktop app, app bar - chat, App bar - Teams
   */
  ModuleSummary = 'Module.Summary',
  PanelLaunchMethod = 'Panel.LaunchMethod',
  /**
   * The region of the page the panel is located in (Ex: Panel_Type = Channel, Panel_Region = Main or Right)
   */
  PanelRegion = 'Panel.Region',
  /**
   * Indicates which panel the action was performed in
   * Sample values: Chat, Channel, taskBarMenu, toast, teamList, chatlisList, activity, notification, documentStage,
   * offlineBanner,{other, alertList, chat, chatList, channel, teamChannelList, meSpace, calendar, calendarList,
   * replyChain, files, fileSources, call, document, team, toast}
   */
  PanelType = 'Panel.Type',
  /**
   * Classifies the scenario driven by a panel action. (Ex: Action_Scenario = "composeSendMessage"
   * is logged when a user clicks on the compose message button)
   */
  Scenario = 'Action.Scenario',
  /**
   * Classifies the type of action scenario (Ex: Action_Scenario = "openFile", Action_ScenarioType = "files")
   */
  ScenarioType = 'Action.ScenarioType'
}

export enum ContextColumns {
  AppId = 'App.Id',
  AppInfoArchVersion = 'AppInfo.ArchVersion',
  AppInfoClientType = 'AppInfo.ClientType',
  AppInfoEnvironment = 'AppInfo.Environment',
  AppInfoExpIds = 'AppInfo.ExpIds',
  AppInfoExperienceName = 'AppInfo.ExperienceName',
  AppInfoHostAppVersion = 'AppInfo.HostAppVersion',
  AppInfoLanguage = 'AppInfo.Language',
  AppInfoLocale = 'AppInfo.Locale',
  AppInfoPlatformId = 'AppInfo.PlatformId',
  AppInfoProcessArchitecture = 'AppInfo.ProcessArchitecture',
  AppInfoVersion = 'AppInfo.Version',
  AppInfoWebVersion = 'AppInfo.WebVersion',
  ChannelId = 'ChannelId',
  Context = 'Context',
  DeviceInfoId = 'DeviceInfo.Id',
  DeviceInfoOsName = 'DeviceInfo.OsName',
  DeviceInfoOsVersion = 'DeviceInfo.OsVersion',
  EventInfoIsSNS = 'EventInfo.isNS',
  PanelContext = 'Panel.Context',
  PanelWindowID = 'Panel.WindowID',
  SessionId = 'Session.Id',
  StartReason = 'startReason',
  TeamId = 'Team.Id',
  TeamOfficeGroupId = 'Team.OfficeGroupId',
  /**
   * The type of the team.
   */
  TeamType = 'Team.TeamType',
  TenantModel = 'Tenant.Model',
  /**
   * Browser UserAgent
   */
  UserAgent = 'userAgent',
  UserInfoETag = 'UserInfo.ETag',
  UserInfoHostETag = 'UserInfo.HostETag',
  UserInfoId = 'UserInfo.Id',
  UserInfoLanguage = 'UserInfo.Language',
  UserInfoLicenseType = 'UserInfo.LicenseType',
  UserInfoRegion = 'UserInfo.Region',
  UserInfoRing = 'UserInfo.Ring',
  UserInfoTeamRole = 'UserInfo.TeamRole',
  UserInfoTenantId = 'UserInfo.TenantId',
  UserInfoTenantRole = 'UserInfo.TenantRole',
  UserRole = 'userRole',
  UserType = 'userType',
  WindowId = 'WindowId',
  WindowType = 'Window.Type'
}

export enum LogLevel {
  Verbose = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4
}

/**
 * The region of the page the panel is located
 * in (Ex: Panel_Type = Channel, Panel.Region = Main or Right)
 * Note: Keep the enums Alphabetically Sorted
 */
export enum PanelRegion {
  Banner = 'banner',
  Dialog = 'dialog',
  Left = 'left',
  Main = 'main',
  Modal = 'modal',
  Popover = 'popover',
  Right = 'right',
  Toast = 'toast',
  Virtual = 'virtual'
}

/**
 * Name of module clicked.
 * Note: Keep the enums Alphabetically Sorted
 */
export enum ModuleName {
  AddMessageFilter = 'addMessageFilter',
  AddProxyEmailButton = 'addProxyEmailButton',
  BulkAssignButton = 'bulkAssignButton',
  BulkUpdateStateDropDown = 'bulkUpdateStateDropDown',
  ChangeAssignedToButton = 'changeAssignedToButton',
  ClearSearchTextButton = 'clearSearchTextButton',
  ConversationPanelButton = 'conversationPanelButton',
  CreateMessageButton = 'createMessageButton',
  FinishSetupWizardButton = 'finishSetupWizardButton',
  FollowingMessageButton = 'followingMessageButton',
  MessageCreateNotificationCheckbox = 'messageCreateNotificationCheckbox',
  MessageDetailsNotificationCheckbox = 'MessageDetailsNotificationCheckbox',
  MessageInputSearchBar = 'messageInputSearchBar',
  MessageTitleTextLink = 'messageTitleTextLink',
  OpenSettingsModalButton = 'openSettingsModalButton',
  RemoveMessageFilterButton = 'removeMessageFilterButton',
  RemoveProxyEmailButton = 'removeProxyEmailButton',
  RemoveResponseTeamListItemButton = 'removeResponseTeamListItemButton',
  RemoveTab = 'removeTab',
  ReplyEmailButton = 'replyEmailButton',
  RetrySubmitSetupWizardButton = 'retrySubmitSetupWizardButton',
  SelectResponseTeamListItem = 'selectResponseTeamListItem',
  SortMessagesColumnButton = 'sortMessagesColumnButton',
  StartSetupWizard = 'startSetupWizard',
  Test = 'test',
  UpdateMessageState = 'updateMessageState',
  UpdateMessageTitle = 'updateMessageTitle',
  ViewEmailButton = 'viewEmailButton'
}

export enum PanelViewOutcome {
  Failure = 'failure',
  Init = 'init',
  None = 'none',
  Success = 'success'
}

/**
 * Outcome of action taken
 * (Ex: Action_Outcome = "read" is logged when "scroll" action happens)
 * Note: Keep the enums Alphabetically Sorted
 */
export enum PanelActionOutcome {
  Disable = 'disable',
  DismissBanner = 'dismissBanner',
  Enable = 'enable',
  Hide = 'hide',
  Inspect = 'inspect',
  Launch = 'launch',
  Nav = 'nav',
  None = 'none',
  OpenChat = 'openChat',
  OpenPopup = 'openPopup',
  Opendialog = 'openDialog',
  Read = 'read',
  RemoveChiclet = 'removeChiclet',
  Retry = 'retry',
  Select = 'select',
  Show = 'show',
  ShowBanner = 'showBanner',
  Submit = 'submit',
  Toggle = 'toggle',
  Update = 'update'
}

export type ActionOutcome = PanelActionOutcome | PanelViewOutcome;

/**
 * Summary of the module's content. Should not include any channel name or team name.
 * Note: Keep the enums Alphabetically Sorted
 */
export enum ModuleSummary {
  AddMessageFilter = 'Add message filter',
  AddProxyEmailButton = 'Add proxy email',
  BulkAssignButton = 'Bulk assignment change',
  BulkUpdateStateDropDown = 'Bulk update state from dropdown',
  ChangeAssignedToButton = 'Change assignedTo',
  ClearSearchTextButton = 'Clear search text button',
  ConversationPanelButton = 'Open conversation panel',
  CreateMessageButton = 'Create new message',
  FinishSetupWizardButton = 'Finish get started setup wizard button',
  FollowingMessageButton = 'Following message button',
  MessageCreateNotificationCheckbox = 'Toggle message create notification setting',
  MessageDetailsNotificationCheckbox = 'Toggle message details Notification setting',
  MessageInputSearchBar = 'Search message',
  MessageTitleTextLink = 'Click message title link',
  OpenSettingsModalButton = 'Open settings modal button',
  RemoveMessageFilterButton = 'Remove message filter',
  RemoveProxyEmailButton = 'Remove Proxy Email Address Button',
  RemoveResponseTeamListItemButton = 'Remove team member list item button',
  RemoveTab = 'removeTab',
  ReplyEmailButton = 'Reply to email in message details',
  RetrySubmitSetupWizardButton = 'Retry submit setupWizard button',
  SelectResponseTeamListItem = 'Select reponse team list item',
  StartSetupWizard = 'Start get started setup wizard',
  UpdateMessageState = 'Update message state',
  UpdateMessageTitle = 'Update Message Title',
  ViewEmailButton = 'View email message'
}
